export const View_Milestone_and_rewards = "view_milestone_and_rewards";
export const complete_your_flag = "complete_your_flag";
export const create_and_share_poster = "create_and_share_poster";
export const Tips_from_experts = "tips_from_experts";
export const Active_student_groups = "active_student_groups";
export const Courses_in_demand = "courses_in_demand";
export const View_checklist = "view_checklist";
export const Milestone_page = "milestone_page";
export const Overview_page = "milestone_page";
export const Tools_page = "tools_page";
export const Checklist_page = "checklist_page";
export const create_and_share_poster_webview = "create_and_share_poster_webview";
export const Tips_from_experts_webview = "tips_from_experts_webview";
export const Active_student_groups_webview = "active_student_groups_webview";
export const Courses_in_demand_webview = "courses_in_demand_webview";
export const Youtube_starter_pack_webview = "youtube_starter_pack_webview";
export const Spin_the_wheeler = "spin_the_wheeler";
export const Quiz_card = "quiz_card";
export const Quiz_submit_answer = "quiz_submit_answer";
export const create_and_share_poster_web = "create_and_share_poster_web";
export const Tips_from_experts_web = "tips_from_experts_web";
export const Courses_in_demand_web = "courses_in_demand_web";
//new 
export const view_leaderboard ="view_leaderboard";
export const view_overview ="view_overview";
export const view_all_milestone ="view_all_milestone";
export const tutor_of_the_day ="tutor_of_the_day";
export const view_all_tasks ="view_all_tasks";
export const redeem_now ="redeem_now";
export const create_polls="create_polls";
export const tips_and_tricks="tips_and_tricks";
export const send_notification="send_notification";
export const star_of_year="star_of_year";



export const ai_convert_banner = "aiconvert_campaign_banner";
export const ai_request_callback ="aiconvert_request_to_callback";
export const studio_callback ="studio_setup_callback";
export const ai_convert_video ="aiconvert_video";

export const bundling_learn_how="bundling_learn_how";
export const revenue_learn_how="revenue_learn_how";
export const trial_live_class_learn_how="trial_live_class_learn_how";
export const notification_learn_how="notification_learn_how";
export const coupon_code_learn_how="coupon_code_learn_how";
export const app_download_learn_how="app_download_learn_how";

export const redeem_now_webview="redeem_now_webview";
 export const create_polls_webview ="create_polls_webview";
 export const tips_and_tricks_webview ="tips_and_tricks_webview";
 export const send_notification_webview ="send_notification_webview";
 export const send_notification_web ="send_notification_web";
 export const year_in_review="year_in_review";
 export const player_card_campaign="player_card_campaign";

export const doubt_mate_banner = 'doubt_mate_banner';
export const super_sets_banner = 'super_sets_banner';
export const money_back_banner = 'money_back_banner';

export const super_sets_request_callback ="super_sets_request_callback";
export const money_back_request_callback ="money_back_request_callback";
export const doubt_mate_request_callback ="doubt_mate_request_callback";

export const sale_video_tutor = 'sale_video_tutor';
export const sale_video_student = 'sale_video_student';

export const view_year_end_review = 'view_year_end_review';


